<template>
  <div class="h-100 container-fluid" v-if="useEmptyLayout">
    <div class="row no-gutters h-100">
      <div class="close-page" @click.prevent="close">
        <i class="pe pe-7s-close"></i>
      </div>
      <div class="col-lg-6 dark-bg">
        <div class="row justify-content-center">
          <div
            class="col-sm-9 align-items-center justify-content-center"
            v-loading="loading"
          >
            <div class="d-flex align-items-center mt-3">
              <router-link :to="homePath" class="logoLogin">
                <LogoIcon sizeWidth="200px" />
              </router-link>
            </div>
            <div class="w-45 max-width margin-auto">
              <div v-if="success" class="colorWhite text-center">
                <h4>Request a new password successfully!</h4>
                <p class="colorGray">
                  Your account has been reset password. <br />
                  <router-link place="link" class="colorWhite" :to="loginPath"
                    >Login</router-link
                  >
                </p>
              </div>
              <form
                id="loginForm"
                class="colorWhite"
                v-else
                :disabled="disabled"
              >
                <h2 class="font-weight-bold mb-2">Reset password</h2>
                <p class="">Enter a new password</p>
                <!-- <md-field class="mb-0">
                  <md-input :value="email" type="email" disabled></md-input>
                </md-field> -->

                <TextField
                  class="mb-0"
                  name="email"
                  :indexField="1"
                  :fieldRequire="true"
                  v-model:value="email"
                  disabled
                />

                <!-- <md-field
                  class="mb-0 input-count"
                  md-has-password
                  v-bind:class="{ 'md-invalid': messageError.password }"
                >
                  <md-input
                    v-model="password"
                    type="password"
                    maxlength="20"
                    placeholder="New password"
                  ></md-input>
                </md-field> -->

                <TextField
                  class="mb-0 input-count"
                  :indexField="1"
                  :fieldRequire="true"
                  v-model:value="password"
                  type="password"
                  maxlength="20"
                  iconPasswordColor="white"
                  placeholder="New password"
                />

                <!-- <md-field
                  class="mb-4"
                  v-bind:class="{ 'md-invalid': messageError.password }"
                >
                  <md-input
                    v-model="confirmPassword"
                    type="password"
                    placeholder="confirm new password"
                  ></md-input>
                  <small class="md-error">{{ messageError.password }}</small>
                </md-field> -->

                <TextField
                  class="mb-4"
                  name="confirm-password"
                  :indexField="2"
                  :fieldRequire="true"
                  v-model:value="confirmPassword"
                  type="password"
                  placeholder="confirm new password"
                  :errorMsg="messageError.password"
                  iconPasswordColor="white"
                />

                <div class="form-group">
                  <button
                    @click.prevent="confirm"
                    class="btn button btn-large btn-primary btn-bounce btn-active w-100"
                  >
                    Reset password
                  </button>
                </div>
              </form>
              <p class="text-center colorGray">
                <span
                  >Already have an account?
                  <router-link class="link" :to="loginPath"
                    >Login now</router-link
                  >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 px-0">
        <div class="boxFix"></div>
      </div>
    </div>
  </div>
</template>
<script src="./index.js"></script>

<style lang="scss" scoped>
.colorDarkGray {
  color: #2e384d;
}
.colorGray {
  color: #b0bac9;
}
.logoLogin {
  img {
    object-fit: cover;
    width: 190px;
    height: auto;
  }
}
// .wrapper {
//   background-color: #fff;
// }
#loginForm {
  font-size: 0.9375rem;
  margin-top: 2rem;
  padding: 2rem;
  // color: #2e384d;
  // opacity: 0.8;
  // background-color: #fff;
  .signInText {
    font-size: 2.125rem;
  }
}
</style>
